/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-21 15:02:55
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/service/permissionService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";
/**
 * 用户列表
 */
export function getPermissionData(Info) {
  return request({
    url:
      "/api/v1/permissions?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 新建Permission页面数据
 */
export function createPermission(data) {
  return request({
    url: "/api/v1/permissions",
    method: "POST",
    data: data
  });
}
/*
 * 编辑Permission页面数据
 */
export function editPermission(data) {
  return request({
    url: "/api/v1/permissions/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取Permission数据详情
 */
export function getPermissionInfo(id) {
  return request({
    url: "/api/v1/permissions/" + id,
    method: "GET"
  });
}
/*
 * 删除Permission数据
 */
export function deletePermission(id) {
  return request({
    url: "/api/v1/permissions/" + id,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/service/permissionService.js